import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
var statusConfig = {
    info: {
        color: 'info.main',
        bgColor: 'rgba(43, 93, 198, 0.04)',
        icon: _jsx(InfoOutlinedIcon, { fontSize: "small" }),
    },
    warning: {
        color: 'warning.main',
        bgColor: 'rgba(237, 108, 2, 0.04)',
        icon: _jsx(WarningAmberOutlinedIcon, { fontSize: "small" }),
    },
    error: {
        color: 'error.main',
        bgColor: 'rgba(211, 47, 47, 0.04)',
        icon: _jsx(ErrorOutlineOutlinedIcon, { fontSize: "small" }),
    },
    success: {
        color: 'success.main',
        bgColor: 'rgba(234, 242, 234, 1)',
        icon: _jsx(CheckCircleOutlineOutlinedIcon, { fontSize: "small" }),
    },
};
export var StatusIndicator = function (_a) {
    var status = _a.status, message = _a.message;
    var config = statusConfig[status];
    if (!config) {
        return null;
    }
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            minHeight: '2.25em',
            padding: '0 0.2rem',
            //margin: '0 0',
            gap: '.3rem',
            backgroundColor: config.bgColor,
            color: config.color,
            fontSize: '0.725rem',
            borderBottomRightRadius: '4px',
            borderBottomLeftRadius: '4px',
        }, children: [config.icon, message] }));
};
